import React, { useEffect, useRef, useState } from "react"

import { Button, Divider, Flex, Modal, Typography } from "antd"
import { useSelector } from "react-redux"

import Icon from "../../Icon"

const { Text } = Typography

const FAQModal = ({ open, close, data, title }) => {
  const isMobile = useSelector((state) => state.nav.isMobile)
  const [activeQuestion, setActiveQuestion] = useState(null)

  useEffect(() => {
    if (open) setActiveQuestion(null)
  }, [open])

  const content = (
    <>
      <div className="faq-description">
        <Text type="secondary" strong>
          {title}
        </Text>
      </div>
      {data.map((faq, i) => (
        <React.Fragment key={faq?.question}>
          <FAQItem
            faq={faq}
            isOpen={activeQuestion === faq?.question}
            setActiveQuestion={setActiveQuestion}
          />
          <Divider style={{ margin: i === data.length - 1 ? "16px 0 0 0" : "16px 0" }} />
        </React.Fragment>
      ))}
    </>
  )

  return (
    <Modal
      open={open}
      onClose={close}
      onCancel={close}
      footer={null}
      centered={!isMobile}
      closeIcon={<Icon type="cross_small" />}
      width={isMobile ? "100%" : 700}
      title={isMobile ? "Frequently asked questions" : "FAQ"}
      destroyOnClose
      afterClose={() => setActiveQuestion(null)}
      className={isMobile ? "faq-custom-modal faq-custom-modal--mobile" : "faq-custom-modal"}
      classNames={{ content: "clear-bg" }}
    >
      {content}
    </Modal>
  )
}

export default FAQModal

const FAQItem = ({ faq, isOpen, setActiveQuestion }) => {
  const contentRef = useRef(null)
  const [height, setHeight] = useState(0)

  useEffect(() => {
    if (isOpen) {
      setHeight(contentRef.current.scrollHeight)
    } else {
      setHeight(0)
    }
  }, [isOpen, faq?.answer])

  const handleClick = () => {
    if (isOpen) setActiveQuestion(null)
    else setActiveQuestion(faq?.question)
  }

  return (
    <Flex gap={8} align="flex-start">
      <Button
        shape="circle"
        type="link"
        size="small"
        icon={<Icon type={isOpen ? "minus" : "plus"} />}
        onClick={handleClick}
        className="faq-plus-btn"
      />
      <Flex vertical gap={isOpen ? 8 : 0}>
        <Text style={{ cursor: "pointer" }} onClick={handleClick} strong>
          {faq?.question}
        </Text>
        <div
          ref={contentRef}
          className="faq-answer"
          style={{
            height: height
          }}
        >
          {typeof faq?.answer === "string" ? (
            <Text type="secondary" style={{ whiteSpace: "pre-line" }}>
              {faq?.answer}
            </Text>
          ) : (
            <>
              <faq.answer />
            </>
          )}
        </div>
      </Flex>
    </Flex>
  )
}
